module.exports = __webpack_public_path__ + "media/images/country_flags/hk-18990ec7a3eb6c7f70aa4858bbd25baf.png";